import React from 'react';
import { Smartphone, Plus } from 'lucide-react';

interface NoAccountBannerProps {
    onAddAccount: () => void;
}

export const NoAccountBanner: React.FC<NoAccountBannerProps> = ({ onAddAccount }) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '13px 20px',
        marginBottom: '24px',
        borderRadius: '14px',
        background: 'rgba(255, 106, 0, 0.06)',
        border: '1px solid rgba(255, 106, 0, 0.2)',
        borderLeft: '3px solid #ff6a00',
    }}>
        <div style={{
            width: '34px',
            height: '34px',
            borderRadius: '10px',
            background: 'rgba(255, 106, 0, 0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
        }}>
            <Smartphone size={17} color="#ff6a00" />
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{
                color: '#f4f4f5',
                fontSize: '13.5px',
                fontWeight: 600,
                margin: 0,
                lineHeight: 1.4,
            }}>
                Para usar essa ferramenta, adicione uma conta Telegram
            </p>
            <p style={{
                color: '#71717a',
                fontSize: '12px',
                margin: '2px 0 0',
                lineHeight: 1.4,
            }}>
                Conecte sua conta pelo menu lateral para continuar
            </p>
        </div>

        <button
            onClick={onAddAccount}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                borderRadius: '10px',
                background: '#ff6a00',
                color: '#fff',
                fontWeight: 700,
                fontSize: '13px',
                border: 'none',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.85')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
        >
            <Plus size={14} />
            Adicionar Conta
        </button>
    </div>
);
